<template>
  <Toast 
    position="bottom-left" 
    :baseZIndex="99999999999"
  />
  <div
    class="vld-parent p-input-filled"
    style="overflow: auto;
            min-height: 100vh;
            display: flex;
            flex-direction: column;
            justify-content: space-between;'"
  >
    <div playwright-id='loading'>
    <loading
      style="z-index: 2000"
      :active="store.state.loader.loading"
      :can-cancel="true"
      :on-cancel="null"
      :is-full-page="true"
    >
      <img
        loading='lazy'
        class="loader-image"
        style="max-width: 400px"
        :src="$store.getters.images.spinner"
      />
    </loading>
    </div>

    <component :is="layout">
      <router-view v-model:layout="layout" />
    </component>
  </div>

  <ChatbotButton></ChatbotButton>
</template>

<script>
import store from "./store";
import Loading from "vue3-loading-overlay";
import "vue3-loading-overlay/dist/vue3-loading-overlay.css";
import DefaultLayout from "./common/layouts/Default";
import BoutiqueLayout from "./common/layouts/Boutique";
import {defineAsyncComponent} from 'vue'
import GeneralVariables from "./common/utils/GeneralVariables";
import { GET_IMAGES, GET_WEBSITE_TEXT, GET_LEGAL_TEXT } from "./common/store/actions";
const Toast = defineAsyncComponent(() =>
  import('primevue/toast')
)

import ChatbotButton from './common/components/ai-chat/ChatbotButton.vue'

export default {
  setup() {
    const layout = DefaultLayout;

    return {
      store,
    };
  },

  created() {},

  computed:{
    layout(){
      if(this.$store.getters.is_boutique)
      {
        return BoutiqueLayout
      }
      else{
        return DefaultLayout
      }
    }
  },
  methods:{
    getColorsCss(){
      var cssId = 'myColors'
    
      if(!document.getElementById(cssId))
      {
        var head = document.getElementsByTagName('head')[0]
        var link = document.createElement('link')
        link.id = cssId
        link.rel = 'stylesheet'
        link.tyle = 'text/css'
        link.href = GeneralVariables.BACKEND + 'api/v1.0/colors.css'
        link.media = 'all'
        head.appendChild(link)
        
      }
    }
  },
  mounted() {
    this.$store.commit("setToast", this.$toast);
    this.$store.commit("setRouter", this.$router);
    this.$store.dispatch('getAllBoutiques');
    this.$store.commit("setDocument", function() {
      return document;
    });

    this.getColorsCss()
    this.$store.dispatch(GET_IMAGES)
    this.$store.dispatch(GET_WEBSITE_TEXT)
    this.$store.dispatch(GET_LEGAL_TEXT)
  },
  components: {
    Loading,
    Toast,
    ChatbotButton
  },
};
</script>

<style lang="scss">

.p-toast {
  @media screen and (max-width: 500px) {
    width: 90% !important;
    margin: auto;
  }
  opacity: 1;
}
.zoomWindow {
  top: -35px !important;
  left: 512px !important;
}
@media screen and (max-width: 1050px) {
  .ZoomContainer {
    display: none;
  }
}

.loader-image {
  @media screen and (max-width: 650px) {
    max-width: 250px !important;
  }
}
::-webkit-scrollbar {
  display: none;
}

::-webkit-scrollbar-thumb {
  background: transparent;
}

a:hover{
  text-decoration: unset !important;
}
</style>
